import React from "react";
import { userTypes } from "../../utils/helpers/constants";
import SuperAdminDashboard from "./atom/admin/SuperAdminDashboard";
import SystemAdminDashboard from "./atom/admin/SystemAdminDashboard";
import StudentDashboard from "./atom/student/StudentDashboard";

export default function Body({
  profile,
  systemMetrics,
  transactionMetrics,
  announcements,
  announcementLoading,
  communityLoading,
  communities,
  events,
  eventListLoading,
  people,
  peopleLoading,
}) {
  const DashboardComponents = () => ({
    [userTypes.ROLE_SYSTEM_ADMIN]: (
      <SystemAdminDashboard
        profile={profile}
        transactionMetrics={transactionMetrics}
        systemMetrics={systemMetrics}
      />
    ),
    [userTypes.ROLE_SUPER_ADMIN]: (
      <SuperAdminDashboard
        profile={profile}
        transactionMetrics={transactionMetrics}
        systemMetrics={systemMetrics}
      />
    ),
    [userTypes.ROLE_USER]: (
      <StudentDashboard
        profile={profile}
        announcements={announcements}
        communities={communities}
        events={events}
        eventListLoading={eventListLoading}
        people={people}
        peopleLoading={peopleLoading}
        announcementLoading={announcementLoading}
        communityLoading={communityLoading}
      />
    ),
  });

  return (
    <div className="app-content hor-content">
      {DashboardComponents()[profile["userType"]]}
    </div>
  );
}
